// extracted by mini-css-extract-plugin
export default {"root":"GivingBackPage_root__Rm2eF","mainContent":"GivingBackPage_mainContent__6oE4H"};